var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreationCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 40,
    height: 40,
    rx: 16,
    fill: "#F59E0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7336 11.5993C28.7335 11.4219 28.699 11.2466 28.6325 11.0862C28.566 10.9259 28.4692 10.7843 28.3491 10.6718C28.229 10.5594 28.0885 10.4787 27.9379 10.4357C27.7872 10.3928 27.6301 10.3885 27.4778 10.4233L16.9778 12.8234C16.7399 12.8777 16.5257 13.0246 16.3718 13.239C16.2179 13.4534 16.1337 13.7221 16.1336 13.9994V24.9366C15.7894 24.845 15.437 24.7991 15.0836 24.7998C13.3437 24.7998 11.9336 25.8739 11.9336 27.1999C11.9336 28.526 13.3437 29.6 15.0836 29.6C16.8234 29.6 18.2336 28.526 18.2336 27.1999V17.3836L26.6336 15.4635V22.5366C26.2894 22.4449 25.937 22.399 25.5836 22.3998C23.8437 22.3998 22.4336 23.4738 22.4336 24.7998C22.4336 26.1259 23.8437 27.1999 25.5836 27.1999C27.3234 27.1999 28.7336 26.1259 28.7336 24.7998V11.5993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationCard2);
export default __webpack_public_path__ + "static/media/creation-card-2.6aead605dd663f8758f8b2b12ef9b4e0.svg";
export { ForwardRef as ReactComponent };